import FilterInput from './filter-input';

export default FilterInput;
